/** Shared sparkle/star icon used by AI gutter button and AI workspace. */

interface Props {
  width?: number;
  height?: number;
  className?: string;
  // 20260916 (coverage image shots, Task 4) — lets a caller give the SVG a stable query hook (the
  // coverage dialog's primary button — common:coverageBlockShots, "Create" — carries a price/time
  // badge that is read off the button's own text, so the icon needs its own handle to assert on/off).
  // Optional and otherwise unused, so every existing caller is unaffected.
  'data-testid'?: string;
}

export function SparkleIcon({ width = 24, height = 24, className, ...rest }: Props) {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" className={className} {...rest}>
      <path
        d="M10 2 L11.5 7.5 L17 9 L11.5 10.5 L10 16 L8.5 10.5 L3 9 L8.5 7.5 Z"
        fill="currentColor"
      />
      <path
        d="M15 2 L15.5 3.5 L17 4 L15.5 4.5 L15 6 L14.5 4.5 L13 4 L14.5 3.5 Z"
        fill="currentColor"
        opacity="0.6"
      />
      <path
        d="M16 13 L16.4 14.2 L17.5 14.5 L16.4 14.8 L16 16 L15.6 14.8 L14.5 14.5 L15.6 14.2 Z"
        fill="currentColor"
        opacity="0.4"
      />
    </svg>
  );
}
